module.exports = __webpack_public_path__ + "MaterialIcons-Regular.e79bfd88537def476913.eot";


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/node_modules/material-design-icons/iconfont/MaterialIcons-Regular.eot
// module id = ../../../../material-design-icons/iconfont/MaterialIcons-Regular.eot
// module chunks = styles